import { addNotify } from 'features/notify';

import { getErrorMessage } from 'shared/utils/getErrorMessage';

const actionTypes = {
  ACTION_PROCESSING: 'bonusProgram/ACTION_PROCESSING',
  GET_CURRENT_GIFTS: 'bonusProgram/GET_CURRENT_GIFTS',
  CURRENT_GIFTS_UPDATE_TRIGGER: 'bonusProgram/CURRENT_GIFTS_UPDATE_TRIGGER',
};

const createGift = (data) => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.bonusProgram.createGift(data);

  if (response.success) {
    dispatch(addNotify(locale.defaultSuccess, 'success'));
    dispatch({ type: actionTypes.CURRENT_GIFTS_UPDATE_TRIGGER });
  } else {
    if (response.errorMessage?.includes('Invalid image dimensions')) {
      dispatch(addNotify(locale.invalidImageSize, 'error'));
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const editGift = (data) => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.bonusProgram.editGift(data);

  if (response.success) {
    dispatch(addNotify(locale.defaultSuccess, 'success'));
    dispatch({ type: actionTypes.CURRENT_GIFTS_UPDATE_TRIGGER });
  } else {
    if (response.errorMessage?.includes('Invalid image dimensions')) {
      dispatch(addNotify(locale.invalidImageSize, 'error'));
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const getCurrentGifts = (data) => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;

  const response = await api.bonusProgram.getCurrentGifts(data);

  if (response.success) {
    dispatch({ type: actionTypes.GET_CURRENT_GIFTS, payload: response.data });
  } else {
    const errorMessage = getErrorMessage(getState().locale.locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

const deleteGift = (data, callback) => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
  const { api } = extra;
  const { locale } = getState().locale;

  const response = await api.bonusProgram.deleteGift(data);

  if (response.success) {
    dispatch({ type: actionTypes.CURRENT_GIFTS_UPDATE_TRIGGER });
    dispatch(addNotify(locale.defaultSuccess, 'success'));
  } else {
    const errorMessage = getErrorMessage(locale, response);
    dispatch(addNotify(errorMessage, 'error'));
  }

  if (callback) {
    callback(response.success ? response.data : null);
  }

  dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
};

export {
  actionTypes,
  createGift,
  editGift,
  getCurrentGifts,
  deleteGift,
};
